import type { IOpenAISchemaFunction } from '@rready/sdk';

export const suggestTicketImprovementDefinition: IOpenAISchemaFunction = {
  type: 'function',
  function: {
    name: 'suggestTicketImprovement',
    description:
      'Given a ticket and a set of similar or duplicate idea in the system, suggest a way to improve the idea to make it more likely to be accepted.',
    parameters: {
      type: 'object',
      properties: {
        reason: {
          type: 'string',
          description:
            'The text of the improvements to be made to my ticket. This should be a human readable text that explains what to change and why.'
        }
      },
      additionalProperties: false,
      required: ['improvementText']
    }
  },
  strict: true
};

export type SuggestTicketImprovementParams = {
  reason: string;
};

export const suggestTicketImprovementImplementation = (
  params: SuggestTicketImprovementParams
) => {
  navigator.clipboard.writeText(params.reason);
};
